(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amo-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      if (!root || root.dataset.agReady) return;
      root.dataset.agReady = '1';

      var grid = root.querySelector('.amo-gal__grid');
      var stash = root.querySelector('.amo-gal__stash');
      var tiles = Array.prototype.slice.call(root.querySelectorAll('.amo-gal__tile'));
      var chips = Array.prototype.slice.call(root.querySelectorAll('.amo-gal__chip'));
      var more = root.querySelector('.amo-gal__more');
      var moreBtn = root.querySelector('.amo-gal__morebtn');
      var mq = window.matchMedia('(max-width: 749px)');
      var step = parseInt(root.dataset.step, 10) || 24;
      var mix = root.dataset.mix === '1';
      var inEditor = !!(window.Shopify && window.Shopify.designMode);
      var cat = 'all';
      var shown = 0;
      var current = [];

      function firstCount() { return mq.matches ? (parseInt(root.dataset.initialM, 10) || 12) : (parseInt(root.dataset.initial, 10) || 24); }
      function colCount() { return mq.matches ? (parseInt(root.dataset.colsM, 10) || 2) : (parseInt(root.dataset.cols, 10) || 4); }

      /* Display order: one category as-is; "All" = round-robin across categories so every album shows up top. */
      function ordered() {
        if (cat !== 'all') return tiles.filter(function (t) { return t.dataset.cat === cat; });
        if (!mix) return tiles.slice();
        var groups = {}, keys = [];
        tiles.forEach(function (t) { var k = t.dataset.cat || '_'; if (!groups[k]) { groups[k] = []; keys.push(k); } groups[k].push(t); });
        var out = [], i = 0, left = tiles.length;
        while (left > 0) { keys.forEach(function (k) { if (groups[k][i]) { out.push(groups[k][i]); left--; } }); i++; }
        return out;
      }

      /* Masonry: place each visible tile in the shortest column (heights from the image aspect ratio). */
      function apply() {
        var list = ordered();
        var vis = inEditor ? list : list.slice(0, shown);
        var n = colCount(), cols = [], h = [];
        for (var i = 0; i < n; i++) { var d = document.createElement('div'); d.className = 'amo-gal__col'; cols.push(d); h.push(0); }
        vis.forEach(function (t) {
          var k = 0; for (var j = 1; j < n; j++) if (h[j] < h[k] - 0.01) k = j;
          cols[k].appendChild(t);
          h[k] += 1 / (parseFloat(t.dataset.ar) || 1) + 0.05;
        });
        grid.classList.add('is-masonry');
        grid.replaceChildren.apply(grid, cols);
        stash.replaceChildren.apply(stash, tiles.filter(function (t) { return vis.indexOf(t) < 0; }));
        current = vis;
        if (more) more.hidden = inEditor || list.length <= shown;
      }

      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          cat = c.dataset.cat;
          chips.forEach(function (x) { var on = x === c; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          shown = firstCount();
          apply();
        });
      });
      if (moreBtn) moreBtn.addEventListener('click', function () { shown += step; apply(); });
      var lastN = colCount();
      window.addEventListener('resize', function () { if (colCount() !== lastN) { lastN = colCount(); apply(); } });
      shown = firstCount();
      apply();

      /* sticky bar sits under the sticky site header */
      var bar = root.querySelector('.amo-gal__bar--sticky');
      if (bar) {
        var top = document.querySelector('.topbar');
        var setTop = function () { root.style.setProperty('--ag-sticky-top', (top ? top.getBoundingClientRect().height : 0) + 'px'); };
        setTop(); window.addEventListener('resize', setTop);
      }

      /* lightbox — walks the photos in the order they are shown */
      var lb = root.querySelector('.amo-gal__lb');
      if (!lb) return;
      var lbImg = lb.querySelector('.amo-gal__lbimg img');
      var lbCap = lb.querySelector('.amo-gal__lbcap');
      var lbCat = lb.querySelector('.amo-gal__lbcat');
      var lbShop = lb.querySelector('.amo-gal__lbshop');
      var lbCount = lb.querySelector('.amo-gal__lbcount');
      var list = [], cur = 0, opener = null;

      function show(i) {
        cur = (i + list.length) % list.length;
        var b = list[cur];
        lbImg.src = b.dataset.full;
        lbImg.alt = b.dataset.cap || '';
        lbCap.textContent = b.dataset.cap || '';
        lbCat.textContent = b.dataset.catname || '';
        if (b.dataset.href) { lbShop.href = b.dataset.href; lbShop.hidden = false; } else { lbShop.hidden = true; }
        lbCount.textContent = (cur + 1) + ' / ' + list.length;
      }
      function open(btn) {
        list = current.map(function (t) { return t.querySelector('.amo-gal__open'); }).filter(Boolean);
        opener = btn;
        lb.hidden = false;
        document.documentElement.classList.add('amo-gal-lock');
        show(Math.max(0, list.indexOf(btn)));
        lb.querySelector('.amo-gal__lbx').focus();
      }
      function close() {
        lb.hidden = true;
        lbImg.removeAttribute('src');
        document.documentElement.classList.remove('amo-gal-lock');
        if (opener) opener.focus();
      }
      root.querySelectorAll('.amo-gal__open').forEach(function (b) { b.addEventListener('click', function () { open(b); }); });
      lb.querySelector('.amo-gal__lbx').addEventListener('click', close);
      lb.querySelector('.amo-gal__lbnav--p').addEventListener('click', function () { show(cur - 1); });
      lb.querySelector('.amo-gal__lbnav--n').addEventListener('click', function () { show(cur + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(cur - 1);
        else if (e.key === 'ArrowRight') show(cur + 1);
      });
      var x0 = null;
      lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 50) show(cur + (dx < 0 ? 1 : -1));
      });
    }

    function initAll() { document.querySelectorAll('.amo-gal').forEach(initGallery); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', function (e) { initGallery(e.target.querySelector('.amo-gal')); });
  })();

  } catch(e) { console.error(e); }
})();
})();
